if (!customElements.get('product-bundle')) {
  customElements.define(
    'product-bundle',
    class ProductBundle extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;
        this.bound = true;

        this.section = this.closest('[data-section-type="product"]') || document;
        this.form = this.section.querySelector('[data-product-form]') || document.querySelector('[data-product-form]');
        this.masterSelect = this.form
          ? this.form.querySelector('[name="id"]')
          : null;
        this.pageVariantId = this.masterSelect ? String(this.masterSelect.value || '') : '';
        this.overrideInput = null;

        this.onClick = (event) => {
          const tile = event.target.closest('[data-bundle-variant]');
          if (tile && !tile.disabled) this.select(tile);
        };
        this.onSubmit = () => this.applySelection();
        this.onMasterChange = () => {
          if (!this.masterSelect) return;
          this.pageVariantId = String(this.masterSelect.value || '');
          const currentTile = this.querySelector('[data-bundle-current]');
          if (currentTile && currentTile.getAttribute('aria-pressed') === 'true') {
            this.applySelection();
          }
        };
        this.onVariantChange = (event) => {
          const variant = event.detail && event.detail.variant;
          if (variant && variant.id) {
            this.pageVariantId = String(variant.id);
            const currentTile = this.querySelector('[data-bundle-current]');
            if (currentTile && currentTile.getAttribute('aria-pressed') === 'true') {
              this.applySelection();
            }
          }
        };

        this.addEventListener('click', this.onClick);
        this.form?.addEventListener('submit', this.onSubmit, true);
        this.masterSelect?.addEventListener('change', this.onMasterChange);
        document.addEventListener('variantChange', this.onVariantChange);
      }

      disconnectedCallback() {
        this.bound = false;
        this.removeEventListener('click', this.onClick);
        this.form?.removeEventListener('submit', this.onSubmit, true);
        this.masterSelect?.removeEventListener('change', this.onMasterChange);
        document.removeEventListener('variantChange', this.onVariantChange);
        this.clearOverride();
      }

      get selected() {
        return this.querySelector('[data-bundle-variant][aria-pressed="true"]');
      }

      select(tile) {
        this.querySelectorAll('[data-bundle-variant]').forEach((item) => {
          item.classList.toggle('is-selected', item === tile);
          item.setAttribute('aria-pressed', item === tile ? 'true' : 'false');
        });
        this.applySelection();

        const portions = this.querySelector('[data-bundle-portions]');
        if (portions) {
          portions.textContent = tile.dataset.portionsText || '';
          portions.hidden = !portions.textContent;
        }
      }

      clearOverride() {
        if (this.overrideInput && this.overrideInput.parentNode) {
          this.overrideInput.parentNode.removeChild(this.overrideInput);
        }
        this.overrideInput = null;
        if (this.masterSelect) {
          this.masterSelect.setAttribute('name', 'id');
          this.masterSelect.removeAttribute('data-bundle-name-cleared');
        }
      }

      ensureOption(select, variantId) {
        const id = String(variantId);
        let option = null;
        for (let i = 0; i < select.options.length; i++) {
          if (select.options[i].value === id) {
            option = select.options[i];
            break;
          }
        }
        if (!option) {
          option = document.createElement('option');
          option.value = id;
          option.setAttribute('data-bundle-foreign', 'true');
          option.hidden = true;
          select.appendChild(option);
        }
        select.value = id;
      }

      applySelection() {
        const tile = this.selected;
        if (!this.form || !tile) return;

        const isCurrent = tile.hasAttribute('data-bundle-current');
        const variantId = isCurrent
          ? this.pageVariantId || tile.dataset.bundleVariant
          : tile.dataset.bundleVariant;

        if (!variantId) return;

        this.clearOverride();

        if (isCurrent && this.masterSelect) {
          this.ensureOption(this.masterSelect, variantId);
          return;
        }

        // Foreign product variant: Debut select only lists current product variants.
        // Prefer a hidden input so ATC gets the correct id without breaking slate.Variants.
        if (this.masterSelect) {
          this.masterSelect.removeAttribute('name');
          this.masterSelect.setAttribute('data-bundle-name-cleared', 'true');
        }

        this.overrideInput = document.createElement('input');
        this.overrideInput.type = 'hidden';
        this.overrideInput.name = 'id';
        this.overrideInput.value = String(variantId);
        this.overrideInput.setAttribute('data-bundle-override', 'true');
        this.form.appendChild(this.overrideInput);
      }
    }
  );
}
